export enum KsefSendParametersSalePatternSendMode {
	NotSend = 'NotSend',
	SendAll = 'SendAll',
	SendB2BOnly = 'SendB2BOnly'
}